import { useEffect, useState } from 'react'
import ReactHowler from 'react-howler'
import { HeaderTitle, MobileTitle } from '../../components/Title'
import ReactGA from 'react-ga4'
import { AllCharacteres } from './AllCharacters'
import { CharPhantoms } from './CharPhantoms'
import { useSearchParams } from 'react-router-dom'
import { CharDlc } from './CharDlc'

export const Characters = () => {
    const [hover, setHover] = useState(false)
    const [isVoiceOn, setIsVoiceOn] = useState(false)
    const [searchParams] = useSearchParams()
    const [voice, setVoice] = useState(1)
    const setCurrent = (e) => {
        setVoice(e)
    }
    const [showModal, setShowModal] = useState(false)
    const [activeCharTab, setActiveCharTab] = useState('characters')
    const [modalImage, setModalImage] = useState()
    const handleOpenModal = (imagepath) => {
        setModalImage(imagepath)
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setShowModal(false)
    }
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }
    useEffect(() => {
        const tab = searchParams.get('tab')
        if (tab) {
            setActiveCharTab(tab)
        }
    }, [searchParams])

    useEffect(() => {
        const scrollTo = searchParams.get('scrollTo')
        if (scrollTo) {
            setTimeout(() => {
                const section = document.getElementById(scrollTo)
                if (section) {
                    section.scrollIntoView({ behavior: 'smooth' })
                }
            }, 100)
        }
    }, [activeCharTab])

    const PhantomsNav = () => {
        return (
            <div className='flex flex-wrap [&>button]:w-[47%] [&>button]:md:w-[24%] [&>button]:max-w-[280px] justify-center gap-4  items-start'>
                <button>
                    <span className='relative inline-block'>
                        <img
                            onClick={() => {
                                setActiveCharTab('characters')
                                scrollToTop()
                            }}
                            className={`${
                                activeCharTab === 'characters' && 'brightness-150'
                            } hover:brightness-150 duration-300 mx-auto`}
                            src={`${process.env.PUBLIC_URL}/images/characters/header-characters-fr.webp`}
                            alt='battle system'
                        />{' '}
                    </span>
                </button>{' '}
                <button>
                    {' '}
                    <span className='relative inline-block '>
                        <img
                            onClick={() => {
                                setActiveCharTab('phantoms')
                                scrollToTop()
                            }}
                            className={`${
                                activeCharTab === 'phantoms' && 'brightness-150'
                            } hover:brightness-150 duration-300 mx-auto`}
                            src={`${process.env.PUBLIC_URL}/images/characters/header-phantoms-fr.webp`}
                            alt='play-it-your-way system'
                        />{' '}
                    </span>
                </button>{' '}
                <button>
                    {' '}
                    <span className='relative inline-block newicon'>
                        <img
                            onClick={() => {
                                setActiveCharTab('dlc')
                                scrollToTop()
                            }}
                            className={`${
                                activeCharTab === 'dlc' && 'brightness-150'
                            } hover:brightness-150 duration-300 mx-auto`}
                            src={`${process.env.PUBLIC_URL}/images/characters/dlc/header-wood-dlc-characters-fr.webp`}
                            alt='play-it-your-way system'
                        />{' '}
                    </span>
                </button>{' '}
            </div>
        )
    }
    return (
        <>
            <div className='md:mt-32'>
                <div className='py-12 md:py-0 w-full text-center mx-auto'>
                    <span className='newicon-mobilenav relative pt-2'>
                        <h1 className='md:hidden text-gradient-title text-lg font-pop inline-block'>Personnages</h1>{' '}
                    </span>
                </div>
                {isVoiceOn && (
                    <ReactHowler
                        src={`${process.env.PUBLIC_URL}/voice/charvoice-0${voice}.wav`}
                        playing={isVoiceOn}
                        volume={0.3}
                        loop={false}
                        onEnd={() => setIsVoiceOn(false)}
                    />
                )}{' '}
                <PhantomsNav />
                {(() => {
                    switch (activeCharTab) {
                        case 'characters':
                            return <AllCharacteres />
                        case 'phantoms':
                            return <CharPhantoms />
                        case 'dlc':
                            return <CharDlc />

                        default:
                            return null
                    }
                })()}
                {/* <AllCharacteres /> */}
            </div>
        </>
    )
}
